"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataAppType;
(function (DataAppType) {
    DataAppType["SimpleData"] = "sd";
    DataAppType["Prestashop"] = "ps";
    DataAppType["Woocommerce"] = "woo";
})(DataAppType = exports.DataAppType || (exports.DataAppType = {}));
//# sourceMappingURL=DataApp.js.map